// import React, { useState, useEffect } from "react";
// import {
//   Search,
//   Heart,
//   User,
//   ShoppingCart,
// } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { collection, onSnapshot, query } from "firebase/firestore";
// import { db } from "../firebase";
// import IconWithBadge from "./IconWithBadge";

// const Header = () => {
//   const navigate = useNavigate();
//   const [cartCount, setCartCount] = useState(0);
//   const [wishlistCount, setWishlistCount] = useState(0);
//   const [showCartBadge, setShowCartBadge] = useState(false);
//   const [showWishlistBadge, setShowWishlistBadge] = useState(false);
//   const userId = "12345"; // Replace with actual user ID from auth

//   useEffect(() => {
//     // Listen to cart changes
//     const cartQuery = query(collection(db, `users/${userId}/cart`));
//     const unsubscribeCart = onSnapshot(cartQuery, (snapshot) => {
//       const newCount = snapshot.docs.length;
//       // Trigger animation by briefly hiding the badge
//       setShowCartBadge(false);
//       setCartCount(newCount);
//       // Show badge with animation
//       setTimeout(() => setShowCartBadge(true), 100);
//     }, (error) => {
//       console.error("Error listening to cart:", error);
//     });

//     // Listen to wishlist changes
//     const wishlistQuery = query(collection(db, `users/${userId}/wishlist`));
//     const unsubscribeWishlist = onSnapshot(wishlistQuery, (snapshot) => {
//       const newCount = snapshot.docs.length;
//       setShowWishlistBadge(false);
//       setWishlistCount(newCount);
//       setTimeout(() => setShowWishlistBadge(true), 100);
//     }, (error) => {
//       console.error("Error listening to wishlist:", error);
//     });

//     // Cleanup listeners on unmount
//     return () => {
//       unsubscribeCart();
//       unsubscribeWishlist();
//     };
//   }, [userId]);

//   const icons = [
//     { Icon: Search, count: 0, show: false, path: "/search" },
//     { Icon: Heart, count: wishlistCount, show: showWishlistBadge, path: "/profile" },
//     { Icon: User, count: 0, show: false, path: "/profile" },
//     { Icon: ShoppingCart, count: cartCount, show: showCartBadge, path: "/cart" },
//   ];

//   return (
//     <header className="bg-gradient-to-r from-purple-900 to-purple-800 shadow-lg sticky top-0 z-50 transition-all duration-300">
//       <div className="container mx-auto px-6 py-2">
//         <div className="flex justify-between items-center">
//           <div className="cursor-pointer" onClick={() => navigate("/")}>
//             <img
//               src={require("../assets/newlogo.png")}
//               alt="Ambaari Jewels"
//               className="h-16 w-auto"
//             />
//           </div>

//           <nav className="hidden md:flex space-x-8">
//             {["Home", "Collections", "About Us", "Contact"].map(
//               (item, index) => (
//                 <a
//                   key={item}
//                   href={`/${["home", "search", "aboutus", "contact"][index]}`}
//                   className="text-purple-100 hover:text-white transition-colors duration-200 font-medium"
//                 >
//                   {item}
//                 </a>
//               )
//             )}
//           </nav>

//           <div className="flex items-center space-x-6">
//             {icons.map((icon, index) => (
//               <IconWithBadge
//                 key={index}
//                 Icon={icon.Icon}
//                 count={icon.count}
//                 show={icon.show}
//                 onClick={() => navigate(icon.path)}
//                 iconClassName="text-purple-100 hover:text-white transition-colors duration-200"
//               />
//             ))}
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;





import React, { useState, useEffect } from "react";
import {
  Search,
  Heart,
  User,
  ShoppingCart,
  Menu,
  X
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { collection, onSnapshot, query } from "firebase/firestore";
import { auth, db } from "../firebase";
import IconWithBadge from "./IconWithBadge";
import { getUserId } from "../utils/utils";

const Header = ({ }) => {
  const navigate = useNavigate();
  const isLoggedIn = auth?.currentUser;
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [showCartBadge, setShowCartBadge] = useState(false);
  const [showWishlistBadge, setShowWishlistBadge] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showAuthDialog, setShowAuthDialog] = useState(false);
  const userId = isLoggedIn ? getUserId() : null; // Replace with actual user ID from auth

  useEffect(() => {
    if (!isLoggedIn) return;

    // Listen to cart changes
    const cartQuery = query(collection(db, `users/${userId}/cart`));
    const unsubscribeCart = onSnapshot(cartQuery, (snapshot) => {
      const newCount = snapshot.docs.length;
      setShowCartBadge(false);
      setCartCount(newCount);
      setTimeout(() => setShowCartBadge(true), 100);
    }, (error) => {
      console.error("Error listening to cart:", error);
    });

    // Listen to wishlist changes
    const wishlistQuery = query(collection(db, `users/${userId}/wishlist`));
    const unsubscribeWishlist = onSnapshot(wishlistQuery, (snapshot) => {
      const newCount = snapshot.docs.length;
      setShowWishlistBadge(false);
      setWishlistCount(newCount);
      setTimeout(() => setShowWishlistBadge(true), 100);
    }, (error) => {
      console.error("Error listening to wishlist:", error);
    });

    return () => {
      unsubscribeCart();
      unsubscribeWishlist();
    };
  }, [userId, isLoggedIn]);

  const handleIconClick = (path) => {
    if (!isLoggedIn) {
      setShowAuthDialog(true);
      return;
    }
    navigate(path);
  };

  const navItems = [
    { label: "Home", path: "/home" },
    { label: "Collections", path: "/search" },
    { label: "About Us", path: "/aboutus" },
    { label: "Contact", path: "/contact" }
  ];

  const icons = [
    { Icon: Search, count: 0, show: false, path: "/search" },
    { Icon: Heart, count: wishlistCount, show: showWishlistBadge, path: "/wishlist", requiresAuth: true },
    { Icon: User, count: 0, show: false, path: "/profile", requiresAuth: true },
    { Icon: ShoppingCart, count: cartCount, show: showCartBadge, path: "/cart", requiresAuth: true }
  ];

  return (
    <>
      <header className="bg-gradient-to-r from-purple-900 to-purple-800 shadow-lg sticky top-0 z-50 transition-all duration-300">
        <div className="container mx-auto px-4 sm:px-6 py-2">
          <div className="flex justify-between items-center">
            <div className="cursor-pointer" onClick={() => navigate("/")}>
              <img
                src={require("../assets/newlogo.png")}
                alt="Ambaari Jewels"
                className="h-12 sm:h-16 w-auto"
              />
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.path}
                  className="text-purple-100 hover:text-white transition-colors duration-200 font-medium"
                >
                  {item.label}
                </a>
              ))}
            </nav>

            {/* Desktop Icons */}
            <div className="hidden md:flex items-center space-x-6">
              {icons.map((icon, index) => (
                <IconWithBadge
                  key={index}
                  Icon={icon.Icon}
                  count={icon.requiresAuth ? (isLoggedIn ? icon.count : 0) : icon.count}
                  show={icon.requiresAuth ? (isLoggedIn && icon.show) : icon.show}
                  onClick={() => handleIconClick(icon.path)}
                  iconClassName="text-purple-100 hover:text-white transition-colors duration-200"
                />
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-purple-100 hover:text-white"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Mobile Menu */}
          <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'} pt-4`}>
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.path}
                  className="text-purple-100 hover:text-white transition-colors duration-200 font-medium"
                >
                  {item.label}
                </a>
              ))}
            </nav>
            <div className="flex justify-start space-x-6 pt-4 border-t border-purple-700 mt-4">
              {icons.map((icon, index) => (
                <IconWithBadge
                  key={index}
                  Icon={icon.Icon}
                  count={icon.requiresAuth ? (isLoggedIn ? icon.count : 0) : icon.count}
                  show={icon.requiresAuth ? (isLoggedIn && icon.show) : icon.show}
                  onClick={() => handleIconClick(icon.path)}
                  iconClassName="text-purple-100 hover:text-white transition-colors duration-200"
                />
              ))}
            </div>
          </div>
        </div>
      </header>

      {/* Auth Dialog */}
      {showAuthDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Sign in to continue</h2>
            <p className="text-gray-600 mb-6">Please sign in to access your wishlist, cart, and profile.</p>
            <div className="space-y-4">
              <button
                className="w-full bg-purple-800 hover:bg-purple-700 text-white py-2 px-4 rounded-lg transition-colors duration-200"
                onClick={() => {
                  setShowAuthDialog(false);
                  navigate('/login');
                }}
              >
                Sign In
              </button>
              <button
                className="w-full border border-gray-300 hover:border-gray-400 text-gray-700 py-2 px-4 rounded-lg transition-colors duration-200"
                onClick={() => {
                  setShowAuthDialog(false);
                  navigate('/register');
                }}
              >
                Create Account
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;